var app = angular.module('leonardo');

var WeekName = function () {
  return function (label) {
    var result = label;
    switch (label){
      case 'week1': result = 'First Week';
        break;
      case 'week2': result = 'Second Week';
        break;
      case 'week3': result = 'Third Week';
        break;
      case 'last_week': result = 'Last Week';
        break;
    }
    return result;
  }
};

app.filter('weekName', [WeekName]);
